/* subscription-free-gift.js  —  Belly Beans (glp-none.myshopify.com)
 * Auto-adds the FREE Reflux Reset Guide ($0.00) to the cart whenever the cart
 * contains a subscription line item, and removes it again if the subscription
 * is taken out. The ebook is added as a one-time $0 line, so it never recurs
 * on future subscription charges: it rides along on the initial order only.
 *
 * Safety: this script only OBSERVES the customer's own cart requests, it never
 * modifies or blocks them, so it cannot break add-to-cart or checkout. All work
 * happens in its own follow-up requests, wrapped in try/catch.
 */
(function () {
  'use strict';

  var EBOOK_VARIANT_ID = 52218432913709;      // FREE Reflux Reset Guide, $0.00
  var INTERNAL_HEADER = 'X-Ebook-Gift';        // tags our own calls so we skip them
  var CART_ROUTES = ['/cart/add', '/cart/change', '/cart/update', '/cart/clear'];

  var routes = window.routes || {};
  var addUrl = routes.cart_add_url || '/cart/add';
  var changeUrl = routes.cart_change_url || '/cart/change';
  var cartUrl = (routes.cart_url || '/cart') + '.js';

  var originalFetch = window.fetch.bind(window);
  var reconciling = false;
  var queued = false;
  var debounce = null;

  function isCartMutation(url) {
    if (!url) return false;
    url = String(url);
    for (var i = 0; i < CART_ROUTES.length; i++) {
      if (url.indexOf(CART_ROUTES[i]) !== -1) return true;
    }
    return false;
  }

  function isEbook(item) {
    return !!item && (item.id == EBOOK_VARIANT_ID || item.variant_id == EBOOK_VARIANT_ID);
  }

  function hasSubscription(cart) {
    return (cart.items || []).some(function (item) {
      return !isEbook(item) && !!item.selling_plan_allocation;
    });
  }

  function getEbookLine(cart) {
    return (cart.items || []).filter(function (item) { return isEbook(item); })[0];
  }

  function getCart() {
    return originalFetch(cartUrl, {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    }).then(function (r) { return r.json(); });
  }

  // Use the theme's own cart UI element + its section list so our refresh
  // matches whatever this theme renders (drawer, notification, upsell, etc.).
  function getCartUI() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function getSectionParam() {
    var ui = getCartUI();
    if (ui && typeof ui.getSectionsToRender === 'function') {
      try {
        return ui.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      } catch (e) {}
    }
    return 'cart-drawer,cart-icon-bubble,cart-live-region-text';
  }

  function refreshCartUI(parsed) {
    // On the full cart page there is no drawer to re-render: reload it.
    if (/\/cart\/?$/.test(window.location.pathname)) {
      window.location.reload();
      return;
    }
    var ui = getCartUI();
    if (ui && typeof ui.renderContents === 'function' && parsed) {
      try { ui.renderContents(parsed); } catch (e) {}
    }
  }

  function internalPost(url, payload) {
    var headers = { 'Content-Type': 'application/json', 'Accept': 'application/json' };
    headers[INTERNAL_HEADER] = '1';
    return originalFetch(url, {
      method: 'POST',
      headers: headers,
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); });
  }

  function addEbook(silent) {
    return internalPost(addUrl, {
      items: [{ id: EBOOK_VARIANT_ID, quantity: 1 }],
      sections: getSectionParam(),
      sections_url: window.location.pathname
    }).then(function (parsed) { if (!silent) refreshCartUI(parsed); });
  }

  function removeEbook() {
    return internalPost(changeUrl, {
      id: String(EBOOK_VARIANT_ID),
      quantity: 0,
      sections: getSectionParam(),
      sections_url: window.location.pathname
    }).then(function (parsed) { refreshCartUI(parsed); });
  }

  function reconcile(silent) {
    if (reconciling) { queued = true; return; }
    reconciling = true;
    getCart().then(function (cart) {
      var sub = hasSubscription(cart);
      var ebook = getEbookLine(cart);
      if (sub && !ebook) return addEbook(silent);   // qualifies, gift missing -> add
      if (!sub && ebook) return removeEbook();       // no subscription -> pull the gift
    }).catch(function () { /* never surface errors to the storefront */ })
      .then(function () {
        reconciling = false;
        if (queued) { queued = false; reconcile(silent); }
      });
  }

  function schedule(silent) {
    clearTimeout(debounce);
    debounce = setTimeout(function () { reconcile(silent); }, 150);
  }

  // --- Observe cart mutations without ever altering them --------------------
  window.fetch = function (input, init) {
    var url = (typeof input === 'string') ? input : (input && input.url);
    var isInternal = false;
    try {
      var hdrs = (init && init.headers) || (input && input.headers);
      if (hdrs) {
        if (typeof hdrs.get === 'function') isInternal = !!hdrs.get(INTERNAL_HEADER);
        else isInternal = !!(hdrs[INTERNAL_HEADER] || hdrs[INTERNAL_HEADER.toLowerCase()]);
      }
    } catch (e) {}

    var promise = originalFetch(input, init);
    if (!isInternal && isCartMutation(url)) {
      promise.then(function (res) { if (res && res.ok) schedule(false); }, function () {});
    }
    return promise;
  };

  // Some apps still drive the cart over XMLHttpRequest.
  var xhrOpen = XMLHttpRequest.prototype.open;
  var xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__ebookMutation = isCartMutation(url);
    return xhrOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    if (this.__ebookMutation) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) schedule(false);
      });
    }
    return xhrSend.apply(this, arguments);
  };

  // Self-heal on load (adds the gift silently if a subscription is already in
  // the cart from a prior session) without popping the drawer open.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { schedule(true); });
  } else {
    schedule(true);
  }
})();
